export default __webpack_public_path__ + "static/media/misc-drawerA-480w.be5e0b3c.png";